import { getRegistrationNumberRegex } from '../../../utils'

export const hasValidRegistrationNumber = (
  registrationNo: string | null | undefined,
  countryId: string | null | undefined,
): boolean => !!registrationNo && getRegistrationNumberRegex(countryId ?? undefined).test(registrationNo)
